/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class SystemPropertiesApi extends BaseApi {
    getGlobalDateFormat(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/system/properties/global-date-format/{tenantId}',
            pathParams
        });
    }
    getPasswordValidationConstraints(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/system/properties/password-validation-constraints/{tenantId}',
            pathParams
        });
    }
    getProperties() {
        return this.get({
            path: '/api/enterprise/system/properties'
        });
    }
    involvedUsersCanEditForms(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/system/properties/involved-users-can-edit-forms/{tenantId}',
            pathParams
        });
    }
}
